<template>
  <article
    v-if="incidence"
    :class="['collapsible-article', { active: element.expanded }]"
  >
    <header
      class="header background-gray"
      :class="incidence.severity"
      @click="expanded()"
    >
      <div
        class="article-icon has-text-centered is-size-1 has-text-grey"
        :class="incidence.severity"
      ></div>
      <div class="article-title pl-2 pr-1">
        <p>
          <span>
            {{ incidence.certified_parcel.requested_parcel.parcel_cadastral_ref }}
          </span>
          <span class="unread" v-if="element.read_status == 'unread'">
            {{ $t("page.labels.unread") }}
          </span>
        </p>
        <p>
          <b>{{ $t("page.labels.parcel_incidence") }}</b>
        </p>
      </div>
      <div class="arrow"></div>
    </header>
    <div
      class="body article-body pa-2"
      :class="incidence.severity"
      v-if="element.expanded"
    >
      <div v-if="incidence.coordinator_description">
        <p v-if="incidence.source_visit">
          {{ $t("page.labels.our_visitor") }} {{ incidence.source_visit.visitor.name }}
          {{ $t("page.labels.visit_comment") }}:
        </p>
        <p v-if="!incidence.source_visit">
          {{ $t("page.labels.visit_comment_no_visitor") }}
        </p>
        <p>&nbsp;</p>
        <p>
          <b>{{ incidence.coordinator_description }}</b>
        </p>
        <p>&nbsp;</p>
      </div>

      <p>
        <b>{{ $t("page.labels.resolution_limit_date") }}:</b>
      </p>
      <p>{{ incidence.resolution_date_limit | localize }}</p>
      <p>&nbsp;</p>

      <div>
        <router-link
          :to="{
            name: 'parcel-detail',
            params: { id: incidence.certified_parcel.requested_parcel.id },
          }"
        >
          <span class="button is-outlined back-white">Ir a la ficha de parcela</span>
        </router-link>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: "NotificationIncidenceCard",
  props: ["element"],
  data() {
    return { incidence: null }
  },
  mounted() {
    this.incidence = this.element.entity
  },
  methods: {
    expanded() {
      this.element.expanded = !this.element.expanded
      this.$emit("expanded", this.element)
    },
  },
}
</script>
